import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authReducer';

// Placeholder for future slices
const store = configureStore({
  reducer: {
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export { store }; 